import React, { createContext, useContext, useEffect, useState } from 'react';

export type FontSizeOption = 'small' | 'medium' | 'large';

interface FontSizeContextType {
  fontSize: FontSizeOption;
  setFontSize: (fontSize: FontSizeOption) => void;
}

const FontSizeContext = createContext<FontSizeContextType | undefined>(undefined);

export const useFontSize = () => {
  const context = useContext(FontSizeContext);
  if (context === undefined) {
    throw new Error('useFontSize must be used within a FontSizeProvider');
  }
  return context;
};

interface FontSizeProviderProps {
  children: React.ReactNode;
}

export const FontSizeProvider: React.FC<FontSizeProviderProps> = ({ children }) => {
  const [fontSize, setFontSizeState] = useState<FontSizeOption>(() => {
    // Check localStorage first
    const savedFontSize = localStorage.getItem('fontSize') as FontSizeOption;
    if (savedFontSize && ['small', 'medium', 'large'].includes(savedFontSize)) {
      return savedFontSize;
    }
    
    // Default to medium
    return 'medium';
  });

  const setFontSize = (newFontSize: FontSizeOption) => {
    setFontSizeState(newFontSize);
    localStorage.setItem('fontSize', newFontSize);
  };

  const value = {
    fontSize,
    setFontSize,
  };

  return (
    <FontSizeContext.Provider value={value}>
      {children}
    </FontSizeContext.Provider>
  );
};













